import validate from 'validate.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const validateElectricalForm = ({
  electrical_system_description = ''
}) => {
  if ('' !== electrical_system_description) {
    return {
      electrical_system_description: validate.single(electrical_system_description,
        {
          length: {
            minimum: 15,
            tooShort: (<FormattedMessage id="hosting.validate_electrical_form.min_character_message" defaultMessage="Enter at least 15 characters"/>)
          }
        })
    };
  }
};

export default validateElectricalForm;
